export default new class ArticleHoverVideo {
	constructor() {
		this.selectors = {
			articleHoverVideo: '.js-article-hover-video'
		};
	}

	init() {
		this.initArticleHoverVideo();
	}

	initArticleHoverVideo() {
		document.querySelectorAll(this.selectors.articleHoverVideo).forEach(article => {
			const videoArticle = article.querySelector('video');

			article.addEventListener('mouseenter', () => {
				videoArticle.classList.remove('hidden');
				article.querySelector('img').classList.add('opacity-0');
				article.querySelector('img').classList.remove('opacity-100');
			});

			article.addEventListener('mouseleave', () => {
				article.querySelector('img').classList.add('opacity-100');
				setTimeout(() => {
					videoArticle.classList.add('hidden');
				}, 100);
				article.querySelector('img').classList.remove('opacity-0');
			});
		});
	}
}